import React from "react";
import moment from "moment";
import { Grid } from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
import DeleteIcon from "@material-ui/icons/Delete";

import { Row } from "../styles";

import { IconWrapper } from "./styles";
import { LeftContentWrapper, NameTypeWrapper, NameWrapper, RightContentWrapper, StyledIconButton, TypeWrapper, Wrapper } from "./sourceFileListItemStyles";

const SourceFileVersionListItem = props => {
  const { sourceFile, deleteSourceFile, downloadFile } = props;
  const createdBy = Boolean(sourceFile.createdBy) && sourceFile.createdBy === "email" ? "Email import" : "Manually uploaded";

  const isVersion = sourceFile.parentId;
  const isRentRoll = (sourceFile.typeId === "rent-roll" || sourceFile.typeId === "mf-rent-roll" || sourceFile.typeId === "mf-rent-roll-charge-code");

  return (
    <Row>
      <Grid container>
        <Wrapper>
          <LeftContentWrapper padding="0 0 0 73px">
            <NameTypeWrapper>
              <NameWrapper>
                {`As of ${sourceFile.asOfDate ? moment.utc(sourceFile.asOfDate).format("MMMM Do, YYYY") : "Unknown"}`}
              </NameWrapper>
              <TypeWrapper>
                {`${createdBy} on ${moment.utc(sourceFile.createdAt).format("MMMM Do, YYYY")}`}
              </TypeWrapper>
            </NameTypeWrapper>
          </LeftContentWrapper>
          <RightContentWrapper>
            <IconWrapper>
              <StyledIconButton onClick={() => downloadFile(sourceFile)}>
                <GetAppIcon />
              </StyledIconButton>
            </IconWrapper>
            {(isVersion  || isRentRoll) && (
              <IconWrapper>
                <StyledIconButton onClick={() => deleteSourceFile(sourceFile)}>
                  <DeleteIcon />
                </StyledIconButton>
              </IconWrapper>
            )}
          </RightContentWrapper>
        </Wrapper>
      </Grid>
    </Row>
  );
};

export default SourceFileVersionListItem;
